import { useCallback, useEffect, useState } from "react";

export function useBottomSheet(initialState = false) {
  const [showSheet, setShowSheet] = useState(initialState);
  const [isAnimating, setIsAnimating] = useState(false);

  // While a sheet is open, the WebView reports "at top" to Android's
  // SwipeRefreshLayout and pulling down inside the sheet triggers a page
  // refresh instead of scrolling. Disable pull-to-refresh for the duration
  // of the sheet, and re-enable when the sheet closes or the component
  // unmounts (e.g. on Turbo navigation with the sheet still open).
  useEffect(() => {
    if (showSheet && window.isApp) {
      window.bridge?.setPullToRefreshEnabled(false);
      return () => window.bridge?.setPullToRefreshEnabled(true);
    }
  }, [showSheet]);

  const toggleSheet = useCallback(() => {
    setShowSheet((prev) => {
      if (prev) {
        setIsAnimating(false);
        setTimeout(() => {
          setShowSheet(false);
        }, 300);
        return prev; // Keep current state, setTimeout will update it
      } else {
        setTimeout(() => {
          setIsAnimating(true);
        }, 10);
        return true;
      }
    });
  }, []);

  const openSheet = useCallback(() => {
    setShowSheet((prev) => {
      if (!prev) {
        setTimeout(() => {
          setIsAnimating(true);
        }, 10);
        return true;
      }
      return prev;
    });
  }, []);

  const closeSheet = useCallback(() => {
    setShowSheet((prev) => {
      if (prev) {
        setIsAnimating(false);
        setTimeout(() => {
          setShowSheet(false);
        }, 300);
      }
      return prev; // Keep current state, setTimeout will update it
    });
  }, []);

  return {
    showSheet,
    isAnimating,
    toggleSheet,
    openSheet,
    closeSheet,
    setIsAnimating,
  };
}
